module.exports = __webpack_public_path__ + "83c36d806dc92327b9e7049a565c6bff.wav";